import { TutorialVideoEnum } from "./tutorialVideoEnum"

export const revitVideoData = {
  name: TutorialVideoEnum.REVIT_GLOBAL,
  thumbnail: "https://ifcjs.github.io/info/img/logo.svg",
}

export const archicadVideoData = {
  name: TutorialVideoEnum.ARCHICAD_GLOBAL,
  thumbnail: "https://ifcjs.github.io/info/img/logo.svg",
}

export const revitVersions = [
  {
    value: "V2023",
    label: "2023",
  },
  {
    value: "V2022",
    label: "2022",
  },
  {
    value: "V2021",
    label: "2021",
  },
]

export const archicadVersions = [
  {
    value: "V28",
    label: "28",
  },
  {
    value: "V27",
    label: "27",
  },
  {
    value: "V26",
    label: "26",
  },
  {
    value: "V25",
    label: "25",
  },
  {
    value: "V24",
    label: "24",
  },
]
